"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<template>
  <div ?hidden="${x => x.totalPages <= 1}">
    
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="pagination-info text-muted">
        ${x => x.getPaginationInfo()}
      </div>
      <div class="pagination-per-page">
        <span class="text-muted">${'pagination.itemsPerPage'.t()}: ${x => x.perPage}</span>
      </div>
    </div>
    
    
    <div class="text-center">
      <nav class="d-inline-block" aria-label="Page pagination">
        <ul class="justify-content-center pagination ${x => x.paginationSizeClass}">
        
        <li class="page-item ${x => x.isFirstPage ? 'disabled' : ''}">
          <button class="prev page-link" 
            ?disabled="${x => x.isFirstPage}"
            @click="${(x, c) => x.changePage(x.previousPage, c.event)}">
            <i class="simple-icon-arrow-left"></i>
          </button>
        </li>
        
        
        <li class="page-item ${x => x.page === 1 ? 'active' : ''}" ?hidden="${x => !x.showFirstPageButton}">
          <button class="page-link" @click="${(x, c) => x.changePage(1, c.event)}">1</button>
        </li>
        
        
        <li class="page-item disabled" ?hidden="${x => !x.showFirstEllipsis}">
          <span class="page-link">${'pagination.ellipsis'.t()}</span>
        </li>
        
        
        ${(0, fast_element_1.repeat)(x => x.getVisiblePages(), (0, fast_element_1.html) `
          <li class="page-item ${(x, c) => c.parent.page === x ? 'active' : ''}">
            <button class="page-link" @click="${(x, c) => c.parent.changePage(x, c.event)}">${x => x}</button>
          </li>
        `)}
        
        
        <li class="page-item disabled" ?hidden="${x => !x.showLastEllipsis}">
          <span class="page-link">${'pagination.ellipsis'.t()}</span>
        </li>
        
        
        <li class="page-item ${x => x.page === x.totalPages ? 'active' : ''}" ?hidden="${x => !x.showLastPageButton}">
          <button class="page-link" @click="${(x, c) => x.changePage(x.totalPages, c.event)}">${x => x.totalPages}</button>
        </li>
        
        
        <li class="page-item ${x => x.isLastPage ? 'disabled' : ''}">
          <button class="next page-link" 
            ?disabled="${x => x.isLastPage}"
            @click="${(x, c) => x.changePage(x.nextPage, c.event)}">
            <i class="simple-icon-arrow-right"></i>
          </button>
        </li>
      </ul>
    </nav>
    </div>
  </div>
</template>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  margin-top: 15px;
  display: block;
}`;
const shadowOptions = { "mode": "open" };
let PaginationComponent = class PaginationComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.currentPage = 1;
        this.totalPages = 1;
        this.showFirstLast = true;
        this.showEllipsis = true;
        this.size = 'sm'; // sm, md, lg
        this.range = 10; // Number of pages to show in pagination
        this.perPage = 1; // Number of items per page
        this.totalItems = 0;
        this.page = 1;
        this.isUpdatingFromParent = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.isUpdatingFromParent = true;
        this.page = this.currentPage || 1;
        this.isUpdatingFromParent = false;
    }
    currentPageChanged(oldValue, newValue) {
        if (newValue !== this.page && !this.isUpdatingFromParent) {
            this.isUpdatingFromParent = true;
            this.page = newValue || 1;
            this.isUpdatingFromParent = false;
        }
    }
    changePage(newPage, event) {
        if (event) {
            event.preventDefault();
        }
        // Ensure newPage is a valid number
        const pageNum = Number(newPage);
        if (isNaN(pageNum) || pageNum < 1 || pageNum > this.totalPages || pageNum === this.page) {
            console.warn('[PAGINATION] Invalid page number:', newPage, 'converted to:', pageNum);
            return;
        }
        // Set flag to indicate this is a user-initiated change
        this.isUpdatingFromParent = false;
        this.page = pageNum;
        // Emit custom event with page number
        this.$emit('page-change', pageNum);
        // Only call callback if we have a page change handler and this is a user action
        if (this.onPageChange && !this.isUpdatingFromParent) {
            this.onPageChange(this.page);
        }
    }
    get isFirstPage() {
        return this.page <= 1;
    }
    get isLastPage() {
        return this.page >= this.totalPages;
    }
    getVisiblePages() {
        const pages = [];
        const range = Number(this.range);
        const totalPages = this.totalPages;
        const currentPage = this.page;
        if (totalPages <= range) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        }
        else {
            let start = Math.max(1, currentPage - Math.floor(range / 2));
            let end = Math.min(totalPages, start + range - 1);
            if (end === totalPages) {
                start = Math.max(1, totalPages - range + 1);
            }
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
        }
        return pages;
    }
    get showFirstPageButton() {
        const start = Math.max(1, this.page - Math.floor(Number(this.range) / 2));
        return this.showFirstLast && start > 1;
    }
    get showFirstEllipsis() {
        return this.showEllipsis && this.page > 3;
    }
    get showPreviousPageButton() {
        return this.page > 1;
    }
    get showNextPageButton() {
        return this.page < this.totalPages;
    }
    get showLastPageButton() {
        const range = Number(this.range);
        const start = Math.max(1, this.page - Math.floor(range / 2));
        const end = Math.min(this.totalPages, start + range - 1);
        return this.showFirstLast && end < this.totalPages;
    }
    get showLastEllipsis() {
        return this.showEllipsis && this.page < this.totalPages - 2;
    }
    get previousPage() {
        return this.page - 1;
    }
    get nextPage() {
        return this.page + 1;
    }
    get paginationSizeClass() {
        return this.size === 'sm' ? 'pagination-sm' :
            this.size === 'lg' ? 'pagination-lg' : '';
    }
    getPaginationInfo() {
        // Access ALL observables first so FAST tracks every dependency
        // regardless of which code path executes
        const totalItems = Number(this.totalItems);
        const page = this.page;
        const perPage = Number(this.perPage);
        if (!totalItems)
            return 'Showing 0 entries';
        const startItem = ((page - 1) * perPage) + 1;
        const endItem = Math.min(page * perPage, totalItems);
        return `app.pagination.pagnation_info`.t({ startItem, endItem, totalItems });
    }
};
exports.PaginationComponent = PaginationComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], PaginationComponent.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], PaginationComponent.prototype, "totalPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], PaginationComponent.prototype, "showFirstLast", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], PaginationComponent.prototype, "showEllipsis", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], PaginationComponent.prototype, "size", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], PaginationComponent.prototype, "range", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], PaginationComponent.prototype, "perPage", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], PaginationComponent.prototype, "totalItems", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], PaginationComponent.prototype, "page", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], PaginationComponent.prototype, "onPageChange", void 0);
exports.PaginationComponent = PaginationComponent = __decorate([
    (0, client_1.RWSView)('app-pagination', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], PaginationComponent);
PaginationComponent.defineComponent();
